module.exports = __webpack_public_path__ + "static/accessori-898af4050c1a5530286ac242a2b81285.jpg";